import { render, staticRenderFns } from "./deliveryZones.vue?vue&type=template&id=5007a485&scoped=true&"
import script from "./deliveryZones.vue?vue&type=script&lang=js&"
export * from "./deliveryZones.vue?vue&type=script&lang=js&"
import style0 from "./deliveryZones.vue?vue&type=style&index=0&id=5007a485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007a485",
  null
  
)

export default component.exports